export default ".no {\n  margin-right: 5px;\n}";